const initialState = {
    data: [],
  };
  
  const grupyWReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_GRUPY_W':
        return { ...state, data: action.payload };
      default:
        return state;
    }
  };
  
  export default grupyWReducer;